/**
 * DropboxBrand.jsx · v2.7.51+E27 (Phase 2 visual-fidelity addendum)
 * ─────────────────────────────────────────────────────────────────────
 * Official Dropbox glyph + wordmark as inline SVGs (asset-loading
 * protocol per the spec — vector, never rasterised, perfect at any
 * scale). Brand colour is Dropbox Blue `#0061FF`.
 *
 *   <DropboxGlyph size={20} />       → just the geometric open-box
 *   <DropboxLockup height={32} />    → glyph + "Dropbox" wordmark
 *
 * The glyph is constructed from 4 large parallelograms + 2 small
 * lower ones that form the iconic "open box" silhouette — same
 * construction Dropbox publishes in its brand guidelines.
 */

const DROPBOX_BLUE = "#0061FF";

export function DropboxGlyph({ size = 20, color = DROPBOX_BLUE, className = "", ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Dropbox"
      role="img"
      {...rest}
    >
      {/* Top-left parallelogram */}
      <polygon fill={color} points="10.5,1 0,7.5 10.5,14 21,7.5" />
      {/* Top-right parallelogram */}
      <polygon fill={color} points="31.5,1 21,7.5 31.5,14 42,7.5" />
      {/* Bottom-left parallelogram */}
      <polygon fill={color} points="0,21 10.5,27.5 21,21 10.5,14.5" />
      {/* Bottom-right parallelogram */}
      <polygon fill={color} points="21,21 31.5,27.5 42,21 31.5,14.5" />
      {/* Small lower-left "flap" */}
      <polygon fill={color} points="10.5,29.5 21,36 31.5,29.5 21,23" />
    </svg>
  );
}

export function DropboxLockup({ height = 28, color = DROPBOX_BLUE, className = "", ...rest }) {
  return (
    <div
      className={`inline-flex items-center gap-2 ${className}`}
      style={{ height }}
      role="img"
      aria-label="Dropbox"
      {...rest}
    >
      <DropboxGlyph size={height} color={color} />
      <span
        style={{
          color,
          fontFamily: '"Sharp Grotesk", "Inter", system-ui, sans-serif',
          fontWeight: 900,
          fontSize: Math.round(height * 0.78),
          lineHeight: 1,
          letterSpacing: "-0.02em",
        }}
      >
        Dropbox
      </span>
    </div>
  );
}

export const DROPBOX_BRAND_BLUE = DROPBOX_BLUE;
export default DropboxGlyph;
